import {
  SET_KIOSKS,
  GET_KIOSK_PRINT_SIZES,
  POPULATE_PRINT_SIZES
} from 'app/actions/types';

import {
  CREATE_KIOSK_PRICING,
  UPDATE_KIOSK_PRICING
} from 'shared/actions/types'

import {
  getKiosks as getKiosksSvc,
  getKiosksV2 as getKiosksSvcV2,
  createKiosk as createKioskSvc,
  updateKiosk as updateKioskSvc,
  updateKioskLocale as updateKioskLocaleSvc,
  uploadSignKioskLocaleAsset as uploadSignKioskLocaleAssetSvc,
  getKioskPrintSizes as getKioskPrintSizesSvc,
  populatePrintSizes as populatePrintSizesSvc
} from 'app/services/kiosks';

import {
  createKioskPricing as createKioskPricingSvc,
  updateKioskPricing as updateKioskPricingSvc,
  deleteKioskPricing as deleteKioskPricingSvc,
} from 'shared/services/PriceService';

import {
  uploadFile as uploadFileSvc
} from 'shared/services/FileService';


export const getKiosksV2 = params => async dispatch => {
  let kiosks = await getKiosksSvcV2(params);

  if (kiosks) {
    dispatch({
      type: SET_KIOSKS,
      payload: kiosks.params
    });
  }

  return kiosks;
}

export const setKioskParams = params => async dispatch => {
  dispatch({
    type: SET_KIOSKS,
    payload: params
  });
}

export const updateKioskLocale = (kioskId, id, params) => async dispatch => {
  let kiosk = await updateKioskLocaleSvc(kioskId, id, params);
  return kiosk;
}

export const uploadKioskLocaleAsset = (kioskId, localeId, assetType, file) => async dispatch => {
  let signed = await uploadSignKioskLocaleAssetSvc(kioskId, localeId, assetType, file.type);
  return await uploadFileSvc(signed.url, file);
}

export const getKioskLocaleAssetUrl = (kioskId, localeId, assetType, fileType) => async dispatch => {
  const res = await uploadSignKioskLocaleAssetSvc(kioskId, localeId, assetType, fileType);
  return res.url;
}

export const getKioskPrintSizes = (accountId) => async dispatch => {
  let printSizes = await getKioskPrintSizesSvc(accountId);
  dispatch({
    type: GET_KIOSK_PRINT_SIZES,
    payload: printSizes
  });
  return printSizes;
}

export const populatePrintSizes = (kioskId) => async dispatch => {
  let printSizes = await populatePrintSizesSvc(kioskId);
  dispatch({
    type: POPULATE_PRINT_SIZES,
    payload: printSizes
  });
  return printSizes;
}

export const createKioskPricing = (kioskId, params) => async dispatch => {
  let pricing = await createKioskPricingSvc(kioskId, params);
  dispatch({
    type: CREATE_KIOSK_PRICING,
    payload: pricing
  });
  return pricing;
}

export const updateKioskPricing = (kioskId, pricingId, params) => async dispatch => {
  let pricing = await updateKioskPricingSvc(kioskId, pricingId, params);
  dispatch({
    type: UPDATE_KIOSK_PRICING,
    payload: pricing
  });
  return pricing;
}

export const deleteKioskPricing = (kioskId, pricingId, params) => async dispatch => {
  return await deleteKioskPricingSvc(kioskId, pricingId);
}
